// extracted by mini-css-extract-plugin
export default {"titleSection":"cKPrn8"};